.searchWrapper {
	margin-top: 5px;
	margin-left: 10px;

	input {
		margin-top: 4px;
		width: 230px !important;
	}
}

.checkBoxStyles {
	margin-top: 5px;
	margin-left: 5px;
	margin-bottom: 5px;
	padding-bottom: 2px;
}

.filterbodyWrapper {
	margin-top: 8px;
	overflow: auto;
	max-height: 250px;
	font-size: 12px;
	margin-left: 5px;
    max-width: 250px;
	min-height: 150px;
}
.spinner{
	min-height: 150px;
    display: flex;
    justify-content: center;
}

.optionsWrapperLone {
    flex: 0.92;
    overflow-y: scroll;
    padding: 5px 0px;
}